import React, { useState } from "react";
import "./style.css";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";

const InActiveSubscription = () => {
  return (
    <div className="inActive_subscription_container">
      <div className="inActive_subscription_body">
        <p className="_title">No Active Subscription</p>
        <p className="_sub_title">
          Subscribe to a plan to access all features and manage your users.
        </p>
        <CustomPrimaryButton title="Subscribe Now" width={200} />
      </div>
    </div>
  );
};

export default InActiveSubscription;
